import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import Header from '../components/header'
import Footer from '../components/footer';
import { PROJECTS, MANAGMENT, ADMINISTRATION } from "../data";
import './index.css'
import './custom.css';

const Layout = ({ children, data }) => (
  <div>
    <Helmet
      title={"Webb Holding LLC"}
      meta={[
        { name: 'description', content: 'Sample' },
        { name: 'keywords', content: 'sample, something' },
      ]}
      script={[
        { src: "https://use.fontawesome.com/releases/v5.0.10/js/all.js", type: "text/javascript" }
      ]}
    />
    <Header />
    <main>
      {children()}
    </main>
    <Footer projects={PROJECTS} managment={MANAGMENT} administration={ADMINISTRATION} />
  </div>
)

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout;



// WEBPACK FOOTER //
// ./src/layouts/index.js